<ion-item>
  <ion-select (ionChange)="select($event)" [value]="current">
    <ion-select-option *ngFor="let layer of baseLayers" [value]="layer.name">{{layer.name}}</ion-select-option>
  </ion-select>
</ion-item>
